import ScreenBackground from "../../templates/ScreenBackground";
import Hand from "../../templates/Hand";

const ScanHand = () => {
    return (
        <>
            <ScreenBackground />
            <Hand />
        </>
    );
};

export default ScanHand;
